import axios from 'axios';
import AppConfig from "../../../../config/AppConfig";

function getBaseURL() {
  // return process.env.NODE_ENV === "development" ? 'http://flow123456.com' : 'https://flow.51homemoney.com'
  return AppConfig.track_server
}

const instance = axios.create({
  baseURL: getBaseURL() //+ '/contract/'
});

const ErrorResponse = {code: 0, msg: '网络错误'}

instance.interceptors.request.use(function (config) {
  if(!config.params) config.params = {}
  config.params.login = localStorage.getItem('login')
  config.params.token = localStorage.getItem('token')
  return config;
});

function DateFormat(date) {
  let year = date.getFullYear();
  let month = ("0" + (date.getMonth() + 1)).slice(-2);
  let sdate = ("0" + date.getDate()).slice(-2);
  return year + '-' + month + '-' + sdate
}

function get(url, data, callback) {
  instance.get(url, {params: data}).then(resp => {
    callback(resp.data)
  }).catch(error => callback(ErrorResponse))
}

function post(url, data, callback) {
  instance.post(url, data).then(resp => {
    callback(resp.data)
  }).catch(error => callback(ErrorResponse))
}
export default class Http {
  static getBaseURL(){
    return getBaseURL()
  }
  static get(url, data, callback){
    get(url, data, callback)
  }
  static post(url, data, callback){
    post(url, data, callback)
  }
  static enUrl(url){
    let login = localStorage.getItem('login')
    let token = localStorage.getItem('token')
    if(url.indexOf('http')!==-1){
      return url;
    }else {
      if(url.indexOf("?")===-1){
        return getBaseURL()+url+`?login=${login}&token=${token}`
      }else {
        return getBaseURL()+url+`&login=${login}&token=${token}`
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Admin/Log/common/Http.js